// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerStyles } from "@steiner/Overrides/Widgets/InvoiceDetails/InvoiceDetailHeader";
import Mail from "@steiner/XDL/Icons/Mail";
import Print from "@steiner/XDL/Icons/Print";
import { hideElementOnPrint } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

headerStyles.buttonGridItem = {
    width: 12,
    css: css`
        justify-content: flex-start;
        gap: 24px;
    `,
};
headerStyles.titleGridItem = {
    width: 12,
    css: css`
        h1 {
            font-size: 16px;
            font-weight: 700;
        }
    `,
};

headerStyles.title = {
    variant: "h1",
    as: "h1",
};

headerStyles.narrowOverflowMenu = {
    cssOverrides: {
        menu: css`
            ${hideElementOnPrint}
        `,
    },
};

headerStyles.printButton = {
    variant: "link" as any,
    mergeCss: true,
    sizeVariant: "small",
    icon: {
        src: Print,
        position: "left",
    },
};

// headerStyles.printButton = {
//     variant: "secondary",
//     mergeCss: true,
//     sizeVariant: "medium",
//     color: "primary",
//     css: css`
//         ${IconWrapper} {
//             top: 0;
//         }`
//     ,
//     icon: {
//         src: Print,
//         position: "right",
//     },
// };

headerStyles.shareEntityButtonStyles = {
    button: {
        variant: "link" as any,
        mergeCss: true,
        icon: {
            src: Mail,
            position: "left",
        },
        sizeVariant: "small",
        color: "primary",
    },
};

headerStyles.headerGridContainer = {
    gap: 0,
};
